@if (totalLength && registerPerPage) {
  <div class="contenedor-paginacion">
    @if (showFisrtLastButton) {
      <button mat-button class="mx-3 btn-first-page " color="primary"
        (click)="executeActionPaginator('goFirst')" [disabled]="pageCurrent === 1">
        Primera
      </button>
    }
    @if (pageCurrent > 3) {
      <button class="mat-elevation-z0" mat-icon-button color="primary"
        (click)="executeActionPaginator('goPrevious')" [disabled]="pageCurrent === 1">
        <i class="fas fa-arrow-left"></i>
      </button>
    }
    @for (range of rangePerPage; track range) {
      @if (range <= totalPages) {
        <button class="mat-elevation-z0" mat-icon-button color="primary"
          (click)="changePage(range)" [class.active]="range === pageCurrent">{{ range }}
        </button>
      }
    }
    <button class="mat-elevation-z0" mat-icon-button color="primary" (click)="executeActionPaginator('goNext')"
      [disabled]="totalPages < pageCurrent">
      <i class="fas fa-arrow-right"></i>
    </button>
    @if (showFisrtLastButton) {
      <button mat-button class="mx-3 btn-last-page " color="primary"
        (click)="executeActionPaginator('goLast')" [disabled]="totalPages < pageCurrent">
        Última
      </button>
    }
  </div>
  @if (showLegends) {
    <p class="leyenda text-center mb-0 txt-texto"> Registros mostrados {{pageStart}} - {{pageEnd}} de
    {{totalLength}} </p>
    <p class="leyenda text-center mb-0 txt-texto">Página {{pageCurrent}} / {{totalPages}}</p>
  }
}